import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Clipboard } from '@angular/cdk/clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { CreatedSiteApiKey } from 'src/app/bo/createdSiteApiKey';

@Component({
  selector: 'app-api-key-display-modal',
  templateUrl: './api-key-display-modal.component.html',
  styleUrls: ['./api-key-display-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class ApiKeyDisplayModalComponent {

  // Set via BsModal initialState
  createdApiKey: CreatedSiteApiKey;

  protected readonly copied = signal(false);

  private readonly bsModalRef = inject(BsModalRef);
  private readonly clipboard = inject(Clipboard);

  protected copyApiKey(): void {
    const success = this.clipboard.copy(this.createdApiKey.apiKey);
    if (success) {
      this.copied.set(true);
      setTimeout(() => this.copied.set(false), 2000);
    }
  }

  protected close(): void {
    this.bsModalRef.hide();
  }
}
